// UPPERCASE enum → display label. "IN_PROGRESS" → "In progress",
// "LIVE" → "Live", "NEEDS_HUMAN" → "Needs human".
export function humanizeEnum(value: string): string {
  return value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^./, (c) => c.toUpperCase());
}
